export enum LocationType {
  residential = 4,
  hotel = 2,
  business = 3,
  airport = 8
}
